import React from 'react'
import arrow_icon from '../Assets/breadcrum_arrow.png'

const Breadcrums = (props) => {
  const {product} = props;
  return (
    <div className='flex flex-wrap items-center gap-2 text-[#6b7a8d] text-xs font-semibold mx-[10%] my-6 uppercase tracking-[1px]'>
      <span className="hover:text-[#00d4ff] cursor-pointer transition-colors">HOME</span>
      <img src={arrow_icon} alt="" className="h-2.5 opacity-40" />
      <span className="hover:text-[#00d4ff] cursor-pointer transition-colors">SHOP</span>
      <img src={arrow_icon} alt="" className="h-2.5 opacity-40" />
      <span className="text-[#a0aec0] hover:text-[#00d4ff] cursor-pointer transition-colors">{product.category}</span>
      <img src={arrow_icon} alt="" className="h-2.5 opacity-40" />
      <span className="text-[#00d4ff] font-bold truncate max-w-[300px]">{product.name}</span>
    </div>
  )
}

export default Breadcrums
